/**
 * A Preview binary may demonstrate checkout, but it must never turn an
 * arbitrary booking/token into a real gateway request.  Keep this policy pure
 * so it is testable outside React Native and used by every money mutation.
 */
export type PreviewMoneyPath = 'fixture' | 'production' | 'blocked'

export function isPreviewMoneyFixtureIdentifier(identifier: string): boolean {
  return identifier.startsWith('tourbook_preview') || identifier.startsWith('preview-')
}

export function resolvePreviewMoneyPath(input: {
  isPreviewRuntime: boolean
  identifier: string
}): PreviewMoneyPath {
  const isFixture = isPreviewMoneyFixtureIdentifier(input.identifier)

  if (input.isPreviewRuntime) return isFixture ? 'fixture' : 'blocked'
  return isFixture ? 'blocked' : 'production'
}
